const inputTokens = ({ fontSizes, colors }) => {
  const focusColors = {
    text: colors.neutrals[0],
    icon: colors.brandPrimary[1],
    color: colors.brandPrimary[1],
    label: colors.brandPrimary[1],
    bg: colors.white,
  };
  const invalidColors = {
    text: colors.neutrals[0],
    icon: colors.negative.default,
    color: colors.negative.default,
    label: colors.negative.default,
    bg: colors.white,
  };
  return {
    space: {
      icon: '40px',
    },
    sizes: {
      icon: {
        container: '40px',
      },
      image: {
        width: '27px',
        height: '27px',
      },
    },
    fontSizes: {
      text: fontSizes.body[1],
      label: fontSizes.body[1],
      shrink: fontSizes.body[0],
      helper: fontSizes.body[0],
    },
    lineHeight: 'initial',
    colors: {
      default: {
        text: colors.neutrals[0],
        icon: colors.neutrals[2],
        color: colors.neutrals[5],
        label: colors.neutrals[0],
        bg: colors.white,
      },
      disabled: {
        text: colors.neutrals[4],
        icon: colors.neutrals[4],
        color: colors.neutrals[5],
        label: colors.neutrals[4],
        bg: colors.neutrals[6],
      },
      negative: invalidColors, // TODO: deprecated: remove when usage will be removed
      invalid: invalidColors,
      branded: focusColors, // TODO: deprecated: remove when usage will be removed
      focus: focusColors,
    },
  };
};

export default inputTokens;
